import { ReactNode } from 'react';

import * as S from './styles';

interface Props {
  title: string;
  subtitle?: ReactNode;
  children?: ReactNode;
}

export default function ResponsivePageHeader({
  title,
  subtitle,
  children,
}: Props) {
  return (
    <S.Header>
      <S.Heading>
        <S.Title>{title}</S.Title>
        {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
      </S.Heading>
      {children}
    </S.Header>
  );
}

export {
  FilterButton as HeaderFilterButton,
  IconButton as HeaderIconButton,
} from './styles';
